import { useMemo, useState } from 'react';
import { Link } from 'react-router';
import { useMeta } from '../../api.ts';
import { Loading, PageHeader, useDocumentTitle } from '../../components/ui.tsx';

export function CountriesPage() {
  useDocumentTitle('Maat');
  const meta = useMeta();
  const [search, setSearch] = useState('');
  const [showDeleted, setShowDeleted] = useState(true);
  const rows = useMemo(() => {
    const s = search.trim().toLowerCase();
    return (meta.data?.countries ?? []).filter(
      (c) => (showDeleted || !c.deleted) && (!s || c.name.toLowerCase().includes(s) || c.code.toLowerCase().startsWith(s) || c.dxcc === s),
    );
  }, [meta.data, search, showDeleted]);

  return (
    <div className="page">
      <PageHeader
        title="Maat"
        sub={meta.data ? `${meta.data.countries.filter((c) => !c.deleted).length} nykymaata, ${meta.data.countries.filter((c) => c.deleted).length} poistunutta` : undefined}
        actions={
          <Link className="btn btn-primary" to="/admin/countries/new">
            + Lisää maa
          </Link>
        }
      />
      <div className="row" style={{ marginBottom: 12 }}>
        <input className="input" style={{ maxWidth: 300 }} placeholder="Hae nimellä, prefiksillä tai DXCC-numerolla…" value={search} onChange={(e) => setSearch(e.target.value)} />
        <label className="check">
          <input type="checkbox" checked={showDeleted} onChange={(e) => setShowDeleted(e.target.checked)} /> Näytä poistuneet
        </label>
      </div>
      {meta.isLoading ? (
        <Loading />
      ) : (
        <div className="table-wrap table-scroll">
          <table className="table">
            <thead>
              <tr>
                <th>Prefiksi</th>
                <th>Nimi</th>
                <th className="num">DXCC</th>
                <th>Tila</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((c) => (
                <tr key={c.id}>
                  <td className="mono">{c.code}</td>
                  <td>
                    <Link to={`/admin/countries/${c.id}`}>{c.name}</Link>
                  </td>
                  <td className="num">{c.dxcc}</td>
                  <td>{c.deleted && <span className="badge">poistunut</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
